import { Stack, Menu, MenuItem, styled } from "@mui/material";

export const StyledSearchContainer = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  backgroundColor: theme.palette.grey[50],
  border: "none",
  borderRadius: 1,
}));

export const StyledIcon = styled("span")(({ theme }) => ({
  color: theme.palette.custom.purple[400],
  transform: "rotate(90deg)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    padding: "0 8px",
    backgroundColor: theme.palette.grey[50],
    borderRadius: "8px",
    boxShadow: theme.shadows[3],
    gap: "8px",
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "14px",
  color: theme.palette.text.primary,
  borderRadius: "6px",
  padding: "12px 8px",
  "&:hover": {
    backgroundColor: theme.palette.grey[100],
  },
}));
